/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent } from 'react';
import { authSelectors } from '../../../../app/auth/auth.selectors';
import { useSelect } from '../../../../utils/selector.utils';
import { CreateMeetingButton } from '../../common/CreateMeetingButton';
import { ControlWrapperProps } from './types';

export const ControlWrapper: FunctionComponent<ControlWrapperProps> = ({ type, sortType, setSortType, children }) => {
  const isAdmin = useSelect(authSelectors.selectUserIsAdmin);
  const addLabel = `Add a New ${type === 'account' ? 'Account' : 'Meeting'}`;

  return (
    <>
      <div className="col-12">
        <div className="panel">
          <div className="panel-header small-header no-border">
            <h2 className="bold">{type === 'account' ? 'Accounts' : 'Meetings'}</h2>
            <div className="ml-auto flex aic jcr">
              <div className="sorting mr-1">
                Sort:
                <a
                  className={`link ${sortType ? 'darkGray' : 'gray'} toggle-link ml-1`}
                  title=""
                  onClick={() => setSortType(1)}
                >
                  A-Z
                </a>
                <a
                  className={`link ${sortType ? 'gray' : 'darkGray'} toggle-link ml-1`}
                  title=""
                  onClick={() => setSortType(0)}
                >
                  Z-A
                </a>
              </div>
              {isAdmin && <CreateMeetingButton label={addLabel} />}
            </div>
          </div>
          {children}
        </div>
      </div>
    </>
  );
};
